export const SearchPropertyLoadingSkeleton = () => {
  return (
    <div className="flex flex-col gap-3">
      <div className="h-[220px] w-[300px] rounded-sm bg-gray-200 animate-pulse" />

      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <div className="h-7 w-32 bg-gray-200 rounded animate-pulse" />
          <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
        </div>

        <div className="flex gap-4 mt-1">
          {[1, 2, 3].map((index) => (
            <div key={index} className="flex items-center gap-1">
              <div className="h-5 w-5 bg-gray-200 rounded animate-pulse" />
              <div className="h-4 w-6 bg-gray-200 rounded animate-pulse" />
            </div>
          ))}
        </div>

        <div className="mt-1 space-y-1">
          <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
          <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
        </div>

        <div className="h-3 w-40 bg-gray-200 rounded animate-pulse mt-6" />
      </div>
    </div>
  );
};
